import { Ship, Wine, Flame, Anchor } from 'lucide-react';
import { makeServicePage } from '../components/ServicePageTemplate';

const page = {
  seo: {
    path: '/cruise-packages',
    title: 'Bucks Cruise Packages Melbourne | Party Boat Hire with Topless Waitresses',
    description: 'Bucks party cruise packages in Melbourne. Private party boat hire on Port Phillip Bay and the Yarra with topless waitresses and strip shows. Enquire for a quote.',
  },
  hero: {
    badge: 'Party Boat Cruises',
    h1: 'Cruise Packages',
    h1Accent: 'Melbourne',
    intro: 'Private party boat cruises with topless waitresses and adult entertainment on board, the ultimate bucks party or celebration on the water.',
    highlight: "Melbourne's most reviewed bucks cruise packages",
    image: '/images/backgrounds/cruise-yacht.jpg',
    bannerImage: '/images/backgrounds/cruise-city.jpg',
  },
  highlights: [
    { icon: Ship, title: 'Private Boat Hire', text: 'Your group on a private vessel cruising the Yarra or Port Phillip Bay.' },
    { icon: Wine, title: 'Topless Waitresses On Board', text: 'Waitresses serving drinks and hosting your group for the whole cruise.' },
    { icon: Flame, title: 'Strip Show Add-ons', text: 'Add a private strip show as the highlight of the trip.' },
    { icon: Anchor, title: 'One Easy Booking', text: 'Boat and entertainment organised together, no juggling suppliers.' },
  ],
  intro: { eyebrow: 'Bucks Cruises Melbourne', title: 'The Ultimate Party on the Water' },
  models: { subtitle: 'Choose the girls you want on board for your cruise.', offset: 16 },
  sections: [
    { p: [
      "There's something about getting the whole group on a boat. Nobody wanders off, the drinks are close by and the view of the city from the water never gets old.",
      'At Topless Waitressing Melbourne, we arrange cruise packages that combine private boat hire with topless waitresses and adult entertainment. It takes the hassle out of organising the venue and the entertainment separately.',
      "Tell us your date, group size and the kind of party you're after, and we'll talk you through the cruise options available.",
    ] },
    { h2: 'Bucks Party Cruises', p: [
      'A bucks cruise is one of the most memorable ways to send off the groom. The group boards together, the waitresses keep the drinks flowing and the party gets going as soon as you leave the dock.',
      'Many groups add a private strip show during the cruise as the highlight of the trip.',
      "If you'd like the groom to be the centre of attention, or would rather keep the focus on the whole group, let us know and we'll plan accordingly.",
    ] },
    { h2: "What's Included in a Cruise Package?", p: [
      'Cruise packages can include private boat hire, topless waitresses and optional strip shows or extra entertainers.',
      'Catering, drinks arrangements and cruise duration vary depending on the vessel and package, so check the details with our team when you enquire.',
      "We'll confirm everything that's included with your quote so there are no surprises on the day.",
    ] },
    { h2: 'Birthday and Private Party Cruises', p: [
      'Cruises are also popular for milestone birthdays, work celebrations and end-of-season trips.',
      "It's a great option for groups who want a private, contained space where everyone can relax and enjoy the entertainment.",
    ] },
    { h2: 'Topless Waitresses on Board', p: [
      'Our topless waitresses look after your group for the duration of the cruise. They serve drinks, chat with guests and help keep the atmosphere fun and social.',
      'Lingerie waitresses are also available if you prefer to start a little more relaxed.',
    ] },
    { h2: 'Where Do Our Cruises Go?', p: [
      'Melbourne cruises typically depart around the Docklands, Southbank or the bay and take in the Yarra River, Port Phillip Bay or the city skyline, depending on the vessel and package.',
      'Departure points, routes and boat sizes vary, so let us know your group size and we can recommend a suitable option.',
    ] },
    { h2: 'How Much Does a Cruise Package Cost?', p: [
      'Pricing depends on the size of the boat, the length of the cruise, the number of entertainers and any extras you add.',
      'Weekends and summer dates book out early, so get in touch as soon as you have a date in mind.',
      "Send us your preferred date, group size and the entertainment you're interested in, and we'll come back with a clear quote.",
    ] },
    { h2: 'Planning Your Cruise', p: [
      'Make sure everyone knows the departure time and location, and arrive early. Boats leave on schedule.',
      'Guests must follow the vessel operator\'s rules and respect the boundaries of every entertainer on board.',
      'A little planning before the day means the whole group can simply enjoy the cruise.',
    ] },
  ],
  faqs: [
    { q: 'How many people can come on a cruise?', a: 'It depends on the vessel. Tell us your group size and we will recommend a suitable boat.' },
    { q: 'Can I add a strip show to my cruise?', a: 'Yes. Strip shows can be added to cruise packages, subject to entertainer availability and vessel rules.' },
    { q: 'Are drinks included?', a: 'Drinks arrangements vary by vessel and package. We will confirm the options with your quote.' },
    { q: 'Where does the boat depart from?', a: 'Departure points vary by vessel. We will confirm the location and time when your booking is arranged.' },
    { q: 'How early should I book a cruise?', a: 'We recommend booking several weeks ahead, especially for weekends and summer dates.' },
    { q: 'What happens if the weather is bad?', a: 'Weather policies depend on the vessel operator. We will explain the relevant conditions before you confirm.' },
  ],
  cta: {
    title: 'Book a Cruise Package in Melbourne',
    text: "Ready to take the party onto the water? Tell us your date and group size and we'll find the right cruise and entertainment for you.",
  },
};

const CruisePackagesPage = makeServicePage(page);
export default CruisePackagesPage;
